import React from 'react'
import { BtInput } from '@linqpal/components/src/ui'
import { useTranslation } from 'react-i18next'
import { EnterManually } from '../components'

const DescriptionOfPublicProject = ({ model, value }) => {
  const { t } = useTranslation('global')
  return (
    <>
      <BtInput
        value={value}
        onChangeText={(val) => model.setValue(val)}
        testID="descriptionOfPublicProject"
        label={t('ProjectForm.description-label')}
      />
      <EnterManually />
    </>
  )
}

export default {
  identifier: 'descriptionOfPublicProject',
  title: 'Description of public project',
  component: DescriptionOfPublicProject,
  optional: true,
}
